import { ChangeEvent, useEffect, useState } from 'react';

import { FormControlLabel, Switch } from '@material-ui/core';
import { DevHubButton, DevHubGrid } from '@devxdiscover/devhub-ui';

const featureFlags = [
  { name: 'DevX ChatBot', key: 'chatbot-flag' },
  { name: 'My Work Homepage Card', key: 'my-work-flag' },
  { name: 'My Ideas Homepage Card', key: 'my-ideas-flag' },
  { name: 'My Tools Homepage Card', key: 'my-tools-flag' },
  { name: 'My Teams Homepage Card', key: 'my-teams-flag' },
  { name: 'My News Homepage Card', key: 'my-news-flag' },
  // Add more feature flags as needed
];

/**
 * A component to render the feature toggles within the Settings Page.
 */
const MyFeatureToggles = () => {
  const [loaded, setLoaded] = useState(false);

  const [flags, setFlags] = useState<{ [key: string]: boolean }>(() => {
    return featureFlags.reduce(
      (acc, feature) => {
        acc[feature.key] = true;
        return acc;
      },
      {} as { [key: string]: boolean },
    );
  });

  useEffect(() => {
    const storedFlags = featureFlags.reduce(
      (acc, feature) => {
        const storedValue = localStorage.getItem(feature.key);
        acc[feature.key] = storedValue === 'true' || storedValue === null;
        return acc;
      },
      {} as { [key: string]: boolean },
    );
    setFlags(storedFlags);
    setLoaded(true);
  }, []);

  const handleToggle =
    (key: string) => (event: ChangeEvent<HTMLInputElement>) => {
      const isEnabled = event.target.checked;
      setFlags(prevFlags => ({ ...prevFlags, [key]: isEnabled }));
      localStorage.setItem(key, isEnabled.toString());
    };

  const handleRestoreDefaults = () => {
    const defaultFlags = featureFlags.reduce(
      (acc, feature) => {
        acc[feature.key] = true;
        localStorage.setItem(feature.key, 'true');
        return acc;
      },
      {} as { [key: string]: boolean },
    );
    setFlags(defaultFlags);
  };

  const allFlagsTrue = Object.values(flags).every(flag => flag);

  return (
    <div>
      <DevHubGrid container spacing={3} justifyContent="flex-end">
        <DevHubButton
          variant="contained"
          color="primary"
          onClick={handleRestoreDefaults}
          disabled={allFlagsTrue}
        >
          Restore Defaults
        </DevHubButton>
      </DevHubGrid>
      {loaded &&
        featureFlags.map(feature => (
          <DevHubGrid item xs={12} key={feature.key}>
            <FormControlLabel
              control={
                <Switch
                  checked={flags[feature.key] || false}
                  onChange={handleToggle(feature.key)}
                  name={feature.key}
                  color="primary"
                />
              }
              label={feature.name}
            />
          </DevHubGrid>
        ))}
    </div>
  );
};

export default MyFeatureToggles;
